// @ts-nocheck
import * as _ from 'lodash-es';
import config from '@/config';

/* Adobe analytics spec:

 Kohdelistaussivulla sivulatauksen yhteydessä data layeriin lisätään:
 adobeAnalyticsData.eVar51 = "kohdehaku"

 Käytetään sekä etusivun kohdehaun ja kohdelistaussivun filtteröinnissä jatkossa
 samaa muuttujaa: adobeAnalyticsData.list3

 List3-muuttujaan asetettuvan datan pitää olla olla aina samassa muodossa sekä
 etusivulla että kohdelistaussivulla (kts. formAnalyticsInput)

 Eri kategoriat erotetaan puolipisteellä. Kategorian eri arvot pilkuilla. Jos joku
 arvo on tyhjä, se pitää silti sisällyttää rimpsuun tyyliin: ;;

 Kohdelistaussivulla filttereitten muuttamisen jälkeen lisätään data layeriin:
 adobeAnalyticsData.list3 = Käyttäjän valitsemien filttereiden arvot pilkulla (,) eroteltuna.
 Eri kategoriat erotetaan puolipisteellä (;)
 */

/* format string for adobeAnalyticsData.list3 */
function formAnalyticsInput(filters, cities, districts, streets, regions) {
  // Myytävät kohteet;Asunnot;Espoo::::,Heinola::::,Helsinki::::,Turku::::,Helsinki:Kamppi:::;,;,;;;;,;,;,;,;
  const mode = filters.mode.value === config.SEARCH_MODES.RENTAL ? 'Vuokrakohteet' : 'Myytävät kohteet';

  // [kohdetyyppi];
  const featureGroup = _.find(config.FEATURE_GROUPS, (group) => group.id === filters.featureGroup.value).name;

  // [sijainti1:kaupunki]:[sijainti1:kaupunginosa]:[sijainti1:postinumero];
  const postalCode = filters.postalCode ? filters.postalCode.value : null;
  const locations = formatLocations(cities, districts, streets, regions, postalCode || null);

  // [myyntihinta:alaraja],[myyntihinta:yläraja];
  const price = [filters.priceMin.value || '', filters.priceMax.value || ''];

  // [pinta-ala:alaraja],[pinta-ala:yläraja];
  const livingArea = [filters.livingAreaMin.value || '', filters.livingAreaMax.value || ''];

  // [huoneluku:arvo1],[huoneluku:arvo2],[huoneluku:arvo3];
  const rooms = filters.numberOfRooms.value || '';

  // [kohdetyyppi:arvo1],[kohdetyyppi:arvo2],[kohdetyyppi:arvo3];
  const listingTypes =
    _.map(filters.type.value, (typeId) => (config.LISTING_TYPES[typeId] ? config.LISTING_TYPES[typeId].name : '')) ||
    '';

  // [lisäominaisuudet:arvo1],[lisäominaisuudet:arvo2],[lisäominaisuudet:arvo3];
  const extraFeatures = _.map(filters.feature.value, (id) => config.EXTRA_FEATURES[id]) || '';

  // [käyttöönottovuosi:alaraja],[käyttöönottovuosi:yläraja];
  const year = [filters.yearMin.value || '', filters.yearMax.value || ''];

  // [vuokra:alaraja], [vuora:yläraja];
  const rent = [filters.rentMin.value || '', filters.rentMax.value || ''];

  // [tontin pinta-ala:alaraja],[tontin pinta-ala:yläraja];
  const siteArea = [filters.siteAreaMin.value || '', filters.siteAreaMax.value || ''];

  // [kokonaispinta-ala:alaraja],[kokonaispinta-ala:yläraja];
  const totalArea = [filters.totalAreaMin.value || '', filters.totalAreaMax.value || ''];

  // [asunnon-kunto:arvo1],[asunnon-kunto:arvo2],[asunnon-kunto:arvo3];
  const condition = _.map(filters.condition.value, (id) => config.APARTMENT_CONDITIONS[id]) || '';

  // [tontin-omistus];
  const siteOwnershipObject = _.find(config.SITE_OWNERSHIP, (type) => type.id === filters.siteOwnership.value);
  const siteOwnership = siteOwnershipObject ? siteOwnershipObject.name : '';

  // [näytöt-ajalta];
  const showingIn = filters.showingIn.value || '';

  const analyticsFilters = [
    mode,
    featureGroup,
    locations,
    price,
    livingArea,
    rooms,
    listingTypes,
    extraFeatures,
    year,
    rent,
    siteArea,
    totalArea,
    condition,
    siteOwnership,
    showingIn,
  ];

  return _.reduce(
    analyticsFilters,
    (result, filter) => {
      let stringifiedFilter = filter;

      if (Array.isArray(filter)) {
        stringifiedFilter = _.reduce(filter, (result, value) => `${result}${value},`, '').slice(0, -1);
      }

      return `${result}${stringifiedFilter};`;
    },
    ''
  );
}

function formatLocations(cities, districts, streets, regions, postalCodes) {
  // [sijainti1-kaupunki]:[sijainti1-kaupunginosa]:[sijainti1-region]:[sijainti1-postinumero],
  // [sijainti2-kaupunki]:[sijainti2-kaupunginosa]:[sijainti2-region]:[sijainti2-postinumero],
  // [sijainti3-kaupunki]:[sijainti3-kaupunginosa]:[sijainti3-region]:[sijainti3-postinumero];
  // E.g. Espoo:::,Helsinki:Kallio::
  // or Helsinki::Etelä-Helsinki:,:::09120,:::78020

  const cityString = _.map(cities, (city) => `${city.city}::::`).join(',');
  const districtString = _.map(districts, (district) => `${district.city}:${district.district}:::`).join(',');
  const streetString = _.map(streets, (street) => `${street.city}::::${street.street}`).join(',');
  const regionString = _.map(regions, (region) => `${region.city}::${region.region}::`).join(',');
  const postalCodeString = _.map(postalCodes, (code) => `:::${code}:`).join(',');

  let locations = [cityString, districtString, regionString, postalCodeString, streetString];
  locations = _.reject(locations, (location) => location === '');
  return locations.join(',');
}

export default {
  formAnalyticsInput,
};
